const initialState = {
    progressStatus : 0
}

const progStatus = (state = initialState , action) =>{
    switch(action.type){
        case "VIDEO_PROGRESS" : 
            return {
                ...state,
                ...{
                    progressStatus : action.payload.progressStatus
                }


            }

        case "RESET_PROGRESS_STATUS" :
            return {
                ...state,
                ...{
                    progressStatus : 0

                }
            }

        default: return state;
    }

   
}

export default progStatus;